export const environment = {
  production: false,
  baseUrl: 'dev.levelab.app',
  s3BaseUrl: 'https://s3-file-uploader-levelab-app-bucket-dev.s3.eu-west-1.amazonaws.com',
  coursesBaseUrl: 'https://0p4pp4h839.execute-api.eu-west-1.amazonaws.com/Courses',
  lessonsBaseUrl: 'https://maw934ihxf.execute-api.eu-west-1.amazonaws.com/Lessons',
  tabsBaseUrl: 'https://0edb3l9lrl.execute-api.eu-west-1.amazonaws.com/Tabs',
  elementsBaseUrl: 'https://44bqugy0v8.execute-api.eu-west-1.amazonaws.com/Elements',
  imagesBaseUrl: 'https://kc7jzxxp65.execute-api.eu-west-1.amazonaws.com/images',
  attachmentsBaseUrl: 'https://kc7jzxxp65.execute-api.eu-west-1.amazonaws.com/attachments',
  usersBaseUrl: 'https://7886a8101d.execute-api.eu-west-1.amazonaws.com/Users',
  metricsBaseUrl: 'https://lom5hmf62f.execute-api.eu-west-1.amazonaws.com/Metrics',
  programsBaseUrl: 'https://vjh94372bj.execute-api.eu-west-1.amazonaws.com/programs',
  categoriesBaseUrl: 'https://vjh94372bj.execute-api.eu-west-1.amazonaws.com/categories',
  imagesBuildBaseUrl: 'https://vjh94372bj.execute-api.eu-west-1.amazonaws.com/images',
  stacksBaseUrl: 'https://aw161zasde.execute-api.eu-west-1.amazonaws.com/stacks',
  fleetsBaseUrl: 'https://aw161zasde.execute-api.eu-west-1.amazonaws.com/fleets',
  sessionsBaseUrl: 'https://g27mj4njy9.execute-api.eu-west-1.amazonaws.com/sessions',
  userBaseUrl: 'https://aw161zasde.execute-api.eu-west-1.amazonaws.com/users',
  organizationsBaseUrl: 'https://rjle1wl6vk.execute-api.eu-west-1.amazonaws.com/organizations',
  logsBaseUrl: 'https://f7iudiu6he.execute-api.eu-west-1.amazonaws.com',
  notificationsBaseUrl: 'https://be59p126v5.execute-api.eu-west-1.amazonaws.com/Notifications',
  postHogKey: 'phc_twLjMgZVwAFDkNGJf3dbHGQ3SuhM3zg89VDEAYhTFgg9',
  postHogHost: 'https://eu.i.posthog.com'
};
